import { render, staticRenderFns } from "./DarkModeSwitcher.vue?vue&type=template&id=655ca71d&scoped=true&"
import script from "./DarkModeSwitcher.vue?vue&type=script&lang=js&"
export * from "./DarkModeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./DarkModeSwitcher.vue?vue&type=style&index=0&id=655ca71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ca71d",
  null
  
)

export default component.exports